import {timelineContainer} from "./timelineContainer";

export class Container extends timelineContainer(PIXI.Container) {

    public destroy(options?: PIXI.DestroyOptions | boolean) {
        if (typeof options === "object") {
            options.children = true;
        }
        super.destroy(options);
    }
}
